<template>
  <div :style="dinamicStyle" class="skeleton-animation">
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

type PropTypes = {
  shape?: 'square' | 'round' | 'circle' | '--'
  size?: 'mini' | 'small' | 'medium' | 'large'
  width?: string | number
  height?: string | number
}

const props = withDefaults(defineProps<PropTypes>(), {
  shape: '--',
  size: 'medium',
  width: '100%',
  height: '100%'
})

const dinamicStyle = computed(() => ({
  width: props.width?.toString()?.includes('px') ? props.width as string: props.width + 'px',
  height: props.height?.toString()?.includes('px') ? props.height as string: props.height + 'px'
}))

</script>

<style scoped>
div{
  height: 20px;
  width: 20px;
  background-color: #EEEEEE;
}
</style>
